module.exports = __webpack_public_path__ + "Georgia.0355b6ac6e6d2730c8c3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Georgia.ttf
// module id = 372
// module chunks = 8